import { useEffect, useState } from 'react';
import { useHistory } from '@useHistory/useHistoryCompat';
import { useLocation } from 'react-router-dom';

export function useEditEntityDialog({
  editEntityQueryParam,
  handleDialog = false
}: {
  editEntityQueryParam: string;
  handleDialog?: boolean;
}) {
  const [editModalConfig, setEditModalConfig] = useState<{
    visible: boolean;
    entityId?: number;
  }>({
    visible: false
  });

  const history = useHistory();
  const location = useLocation();

  const updateConfig = () => {
    const search = new URLSearchParams(history.location.search);

    if (search.get(editEntityQueryParam)) {
      setEditModalConfig({
        visible: true,
        entityId: parseInt(search.get(editEntityQueryParam), 10)
      });
    } else {
      setEditModalConfig(prev => ({
        ...prev,
        visible: false
      }));
    }
  };

  useEffect(() => {
    if (!handleDialog) {
      return;
    }

    updateConfig();
  }, [location]);

  const navigate = (seqId: number, extraParams = {}) => {
    const search = new URLSearchParams(history.location.search);
    if (seqId) {
      search.set(editEntityQueryParam, `${seqId}`);
    } else {
      search.delete(editEntityQueryParam);
    }

    Object.keys(extraParams).forEach(key => {
      if (typeof extraParams[key] === 'undefined') {
        search.delete(key);
      } else {
        search.set(key, extraParams[key]);
      }
    });

    history.push({ search: search.toString() });
  };

  return {
    editModalConfig,
    navigate
  };
}
